// angular
import { Component, OnInit } from '@angular/core';

// others
import { PrivacyStatementService } from './privacy-statement.service';
import { AppService } from '../app.service';
import { LanguageModel, TemplateContent } from '../models';
import { TermsConditionComponent } from '../terms-condition/terms-condition.component';

@Component({
    selector: 'app-privacy',
    templateUrl: './privacy-statement.component.html',
    providers: [PrivacyStatementService]
})

export class PrivacyStatementComponent extends TermsConditionComponent implements OnInit {
    content = {};
    get locale() {
        return this.appService.getLanguage();
    }
    constructor(
        public service: PrivacyStatementService,
        public appService: AppService
    ) {
        super(service, appService);
    }

    ngOnInit() {
        this.getContent(this.service);
    }
}
